const hotel = {
  availableMealPlans: "Paket Makan yang Tersedia", // translated 
  availableRoomsTypes: "Tipe Kamar yang Tersedia", // translated 
  cancellationPolicy: "Kebijakan Pembatalan", // translated 
  cancellationRules: "Aturan Pembatalan", // translated 
  freeCancellationAvailable: "Pembatalan Gratis Tersedia", // translated 
  nonRefundable: "Tidak bisa dikembalikan", // translated 
  priceFor: "Harga untuk", // translated 
  nights: "malam", // translated 
  totalPrice: "Total harga", // translated 
  seeAvailability: "Lihat Ketersediaan", // translated 
  myProfile: "Profil saya", // translated 
  travelTrust: "Kepercayaan Perjalanan", // translated 
  signIn: "Masuk", // translated 
  searchNow: "Cari sekarang", // translated 
  policy: "Kebijakan", // translated 
  cxlRules: "Aturan CXL", // translated 
  room: "ruang", // translated 
  cxlPolicy: "Kebijakan CXL", // translated 
  beddingType: "Jenis Tempat Tidur", // translated 
  hotelName: "Nama hotel", // translated 
  reservationDate: "Tanggal Reservasi", // translated 
  maxPax: "Maks Orang", // translated 
};


export default hotel;
